import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import categoryService from '../category/categoryService'
import { toast } from 'react-toastify'

const initialState = {
    categories: [],
    category: '',
    image: '',
    error: false,
    loading: false,
}

export const categoryCreate = createAsyncThunk('category/categoryCreate', async (category, thunkAPI) => {
    try {
       return await categoryService.categoryCreate(category)
    } catch (error) {
         return thunkAPI.rejectWithValue(error.response.data)
    }
})

export const categoryUpdate = createAsyncThunk('category/categoryUpdate', async ({ id, body }, thunkAPI) => {
    try {
        return await categoryService.updateCategory(id, body)
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || error.message)
    }
})

export const categoryDelete = createAsyncThunk('category/categoryDelete', async (id, thunkAPI) => {
    try {
        return await categoryService.deleteCategory(id)
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || error.message)
    }
})

export const getCategories = createAsyncThunk('category/getCategories', async (_, thunkAPI) => {
    try {
       return await categoryService.getCategories()
    } catch (error) {
         return thunkAPI.rejectWithValue(error.response.data)
    }
})

export const categorySlice = createSlice({
    name: 'category',
    initialState,
    reducers: {
     handleChange: (state, { payload: { name, value } }) => {
        state[name] = value
    },
    clearValues: () => {
      return {
        ...initialState,
      }
    }
    },
    extraReducers: (builder) => {
        builder
        .addCase(categoryCreate.pending, (state) => {
            state.loading = true
        })
        .addCase(categoryCreate.fulfilled, (state) => {
            state.loading = false
            toast.success('category added')
        })
        .addCase(categoryUpdate.fulfilled, (state, action) => {
            state.loading = false
            // replace updated category in list if present
            const updated = action.payload;
            if (updated && Array.isArray(state.categories)) {
                state.categories = state.categories.map(c => (String(c._id) === String(updated._id) ? updated : c));
            }
            toast.success('category updated')
        })
        .addCase(categoryDelete.fulfilled, (state, action) => {
            state.loading = false
            const id = action.meta.arg;
            state.categories = (state.categories || []).filter(c => String(c._id) !== String(id));
            toast.success('category deleted')
        })
        .addCase(categoryCreate.rejected, (state) => {
            state.loading = false
            state.error = true
            //toast.error('category error')
        })
        .addCase(getCategories.pending, (state) => {
            state.loading = true
        })
        .addCase(getCategories.fulfilled, (state, action) => {
            state.loading = false
            state.categories = action.payload
        })
        .addCase(getCategories.rejected, (state) => {
            state.loading = false
            state.error = true
        })        
    }
})

export const { handleChange, clearValues } = categorySlice.actions;
export default categorySlice.reducer